import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

// Contenido y funciones del servicio
const funciones = [
  "Función 1",
  "Función 2",
  "Función 3",
  "Función 4",
  "Función 5"
];

const GestorPedidosCompra = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      <div className="fondo-aplicacion">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo Gestor de Pedidos de Compra"
        />
        <div className="fondo-aplicacion-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-aplicacion">Gestor de Pedidos de Compra</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/gestorpedidoscompra1.jpg`}
          alt="Gestor de Pedidos de Compra 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Gestiona y organiza todos los pedidos de compra en tu empresa. Desde la creación hasta el seguimiento y entrega, todo en un solo lugar.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/gestorpedidoscompra${num}.jpg`}
                alt={`Gestor de Pedidos de Compra ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/gestorpedidoscompra${num}.jpg`}
              alt={`Gestor de Pedidos de Compra ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>Optimiza el Pedido de Compras</h2>
        <p>Gestiona tus pedidos y mantén todo bajo control.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default GestorPedidosCompra;
